const Vapor = (await import('laravel-vapor')).default;
window.Vapor = Vapor;
window.Vapor.withBaseAssetUrl(import.meta.env.VITE_VAPOR_ASSET_URL)

import $ from 'jquery';
window.$ = window.jQuery = $;

window._ = (await import('lodash')).default;

window.bootstrap = await import('bootstrap');

window.axios = (await import('axios')).default;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.DOMPurify = (await import('dompurify')).default;

window.he = (await import('he')).default;

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Require MPG global namespace and global libs
//
///////////////////////////////////////////////////////////////////////////////////////////////////
await import('./mpgapp');

// Datatables - Order dependent
await import('datatables.net-bs5');
await import('datatables.net-buttons-bs5');
await import('datatables.net-rowreorder');
await import('datatables.net-rowreorder-bs5');

//require('datatables.net-colreorder-bs5');
await import('datatables.net-buttons/js/buttons.colVis.mjs');
await import('datatables.net-buttons/js/buttons.html5.mjs');
// await import('datatables.net-buttons/js/buttons.flash.mjs');
await import('datatables.net-buttons/js/buttons.print.mjs');

await import('datatables.net-responsive');
await import('datatables.net-responsive-bs5');
await import('datatables.net-fixedheader-bs5');
await import('datatables.net-datetime');

await import('datatables.net-fixedcolumns-bs5');

await import('./datatable-editor/dataTables.editor.js');
await import('./datatable-editor/editor.bootstrap5.js');

await import('./vendor/datatables/buttons.server-side.js');

// select2
const select2 = await import('select2');
if (typeof select2.default === 'function') {
    select2.default(window, jQuery);
}

// ckeditor
await import('./ckeditor/_include');

// Load jquery-slimscroll
await import('jquery-slimscroll');

// Load moment.js
const moment = (await import('moment-timezone')).default;
window.moment = moment;

// jQuery Form -- TODO last release of this was in 2020, consider replacing with a maintained alternative. _jquery.uploader.js looks like the only place this is used right now.
const jQueryForm = await import('../../node_modules/jquery-form/src/jquery.form.js');
if (typeof jQueryForm.default === 'function') {
    jQueryForm.default(window, $);
}

// bootstrap-autocomplete
await import('bootstrap-autocomplete');

// Load jQuery Mask
await import('jquery-mask-plugin');

// jquery.cookie
await import('jquery.cookie');

// intro.js
const introJs = (await import('intro.js')).default;
window.introJs = introJs;

await import('jquery-ui/ui/data');
await import('jquery-ui/ui/scroll-parent'); // Required for sortable
await import('jquery-ui/ui/widget');
await import('jquery-ui/ui/widgets/mouse');
await import('jquery-ui/ui/widgets/sortable');
await import('jquery-ui/ui/widgets/accordion'); // Still load this after mouse, etc.

// Custom JS libs
await import('./lib/_jquery.forceNumeric.js');
await import('./lib/_jquery.clearText.js');
await import('./lib/_jquery.fieldLib.js');
await import('./lib/_jquery.fieldValidate.js');
await import('./lib/_jquery.highlight.js');
await import('./lib/_jquery.uploader.js');

const JSZip = (await import('jszip')).default;
window.JSZip = JSZip;

// daterangepicker
await import('daterangepicker');

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Require MPGApp specific js namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
await import('./alerts');
await import('./datatables');
await import('./datatables/search.js');
await import('./expandable');
await import('./idletimeout');
await import('./app_switcher');
await import('./recaptcha');
await import('./module-selector');
await import('./zendesk');

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Require MPGApp routes
//
///////////////////////////////////////////////////////////////////////////////////////////////////


await import('../../Modules/Ribit/Resources/assets/js/app.js');

await Promise.all([
    import('../../Modules/Auditmodule/Resources/assets/js/app.js'),
    import('../../Modules/SmartAttGen/Resources/assets/js/app.js'),
    import('../../Modules/SmartVault/Resources/assets/js/app.js'),
    import('../../Modules/SmartVaultPOS/Resources/assets/js/app.js'),
]);

await Promise.all([
    // Auth related namespaces
    import('./routes/auth/_login.js'),

    // Dashboard namespaces
    import('./routes/_dashboard.js'),

    // Form related namespaces
    import('./forms/_form_wizard.js'),

    // Role namespaces
    import('./routes/roles/_show.js'),

    // SmartTrax namespaces
    import('./routes/smart_trax/accounts/_common.js'),
    import('./routes/smart_trax/accounts/_create.js'),
    import('./routes/smart_trax/accounts/_show.js'),
    import('./routes/smart_trax/brokers/_common.js'),
    import('./routes/smart_trax/brokers/_create.js'),
    import('./routes/smart_trax/brokers/_show.js'),
    import('./routes/smart_trax/clients/_common.js'),
    import('./routes/smart_trax/clients/_create.js'),
    import('./routes/smart_trax/clients/_show.js'),
    import('./routes/smart_trax/contacts/_common.js'),
    import('./routes/smart_trax/contacts/_create.js'),
    import('./routes/smart_trax/promotions/_common.js'),
    import('./routes/smart_trax/promotions/_create.js'),
    import('./routes/smart_trax/promotions/_grid.js'),
    import('./routes/smart_trax/promotions/_index.js'),
]);

await mpgapp.register();
await mpgapp.datatables.register();

await Promise.all([
    mpgapp.fieldLib.register(),
    window.fieldValidate.register(),
    mpgapp.uploader.register(),
    mpgapp.datatables.search.register(),
    mpgapp.alerts.register(),
    mpgapp.expandable.register(),
    mpgapp.idletimeout.register(),
    mpgapp.app_switcher.register(),
    mpgapp.moduleselector.register(),
    mpgapp.zendesk.register(),
]);
